module.exports = __webpack_public_path__ + "media/forge_trait.972c46f1.mp4";